import { formatDateTime } from '../../../../utils/hubspotUtils';
import { Field, FieldGrid } from '../../../common/detailParts';
import { PanelSection } from '../../PanelSection';
import type { HubspotTicketDetailData } from '../../types';

interface HubspotTicketWorkflowSectionProps {
  closureDetails: NonNullable<HubspotTicketDetailData['closureDetails']>;
}

export function HubspotTicketWorkflowSection({
  closureDetails,
}: HubspotTicketWorkflowSectionProps) {
  return (
    <PanelSection title="Closure">
      <FieldGrid cols={2}>
        <Field label="Category">{closureDetails.category}</Field>
        <Field label="Label">{closureDetails.label}</Field>
        <Field label="Reviewed by">
          {closureDetails.reviewedBy
            ? `${closureDetails.reviewedBy.fullName} (${closureDetails.reviewedBy.email})`
            : '—'}
        </Field>
        <Field label="Reviewed at">
          {closureDetails.reviewedAt
            ? formatDateTime(closureDetails.reviewedAt)
            : '—'}
        </Field>
        {closureDetails.reviewerNote && (
          <Field label="Reviewer note" className="sm:col-span-2">
            <div className="whitespace-pre-wrap text-neutral-200">
              {closureDetails.reviewerNote}
            </div>
          </Field>
        )}
      </FieldGrid>
    </PanelSection>
  );
}
